export const API_URL = "https://akb.it-factum.de"
